import styled from '@emotion/styled';
import {
  space,
  typography,
  layout,
  flexbox,
  grid,
  border,
  background,
  color,
} from 'styled-system';

const Box = styled('div')(
  space,
  typography,
  layout,
  flexbox,
  grid,
  border,
  background,
  color
);

export default Box;
